import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Check, Clock, ShieldCheck, Download, CreditCard, RefreshCw } from 'lucide-react';
export function PricingSection() {
  // Countdown timer logic (2 hours)
  const [timeLeft, setTimeLeft] = useState(7200);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section id="compra" className="py-24 bg-[#1E3A5F] relative scroll-mt-10" data-id="element-279">
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-280"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-281">
        <div className="text-center mb-12" data-id="element-282">
          <div className="inline-flex items-center bg-red-600 text-white px-6 py-2 rounded-full font-bold text-lg mb-8 shadow-lg animate-pulse" data-id="element-283">
            <Clock className="w-5 h-5 mr-2" data-id="element-284" />
            ESTA OFERTA EXPIRA EN: {formatTime(timeLeft)}
          </div>

          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-285">
            Elegí tu Mega Pack Aprendizaje Lectura:
          </h2>
          <p className="text-xl text-amber-300 font-medium" data-id="element-286">
            Todas las opciones incluyen los 3 bonos
          </p>
        </div>

        <div className="max-w-lg mx-auto mb-16" data-id="element-287">
          <div className="bg-gradient-to-b from-amber-50 to-white rounded-3xl p-8 md:p-10 shadow-2xl border-4 border-[#F59E0B] flex flex-col relative" data-id="element-288">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#F59E0B] text-white font-black px-6 py-2 rounded-full shadow-lg uppercase tracking-wide" data-id="element-289">
              MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-4 text-center" data-id="element-290">
              <h3 className="text-2xl font-bold text-[#1E3A5F] flex items-center justify-center mb-2" data-id="element-291">
                <span className="text-3xl mr-2" data-id="element-292">🏆</span> PRIMARIA COMPLETA (1º
                A 6º)
              </h3>
              <p className="text-slate-600 font-medium" data-id="element-293">
                Los 6 grados + los 3 bonos + Plan Lector Anual unificado
              </p>
            </div>

            <div className="mb-8 text-center" data-id="element-294">
              <p className="text-slate-400 line-through text-xl font-medium" data-id="element-295">
                $48.600 ARS
              </p>
              <p className="text-6xl font-black text-[#16A34A]" data-id="element-296">
                $19.990{' '}
                <span className="text-2xl text-slate-500 font-bold" data-id="element-297">ARS</span>
              </p>
            </div>

            <Button href="Link de tu checkout" variant="primary" size="xl" fullWidth className="shadow-xl shadow-green-500/30 text-lg md:text-xl" data-id="element-298">
              👉 Quiero mis lecturas →
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-16 text-white" data-id="element-299">
          <div className="flex items-center" data-id="element-300">
            <CreditCard className="w-5 h-5 mr-2 text-amber-400" data-id="element-301" /> ✔ Pago único
          </div>
          <div className="flex items-center" data-id="element-302">
            <Clock className="w-5 h-5 mr-2 text-amber-400" data-id="element-303" /> ✔ Acceso
            inmediato
          </div>
          <div className="flex items-center" data-id="element-304">
            <Download className="w-5 h-5 mr-2 text-amber-400" data-id="element-305" /> ✔ Descarga
            ilimitada
          </div>
          <div className="flex items-center" data-id="element-306">
            <RefreshCw className="w-5 h-5 mr-2 text-amber-400" data-id="element-307" /> ✔ Sin
            suscripciones
          </div>
        </div>

        {/* What's included summary */}
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12 max-w-3xl mx-auto" data-id="element-308">
          <h4 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-309">
            EL MEGA PACK COMPLETO INCLUYE:
          </h4>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-310">
            {['192 lecturas narrativas listas para imprimir (1º a 6º)', '192 fichas de actividades de comprensión', 'Plan lector anual semana a semana', '6 carpetas digitales organizadas por grado', 'Banco de 150 consignas inteligentes', 'Kit de emergencia con 58 herramientas', 'Sistema de seguimiento para padres y directivos'].map((item, i) => <li key={i} className="flex items-start text-blue-50" data-id="element-311">
                <Check className="w-6 h-6 text-[#16A34A] mr-3 flex-shrink-0 bg-white rounded-full p-1" data-id="element-312" />
                <span className="font-medium" data-id="element-313">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}